import React, { useEffect, useState } from "react";
import {
  updateFormContentPreview,
  getFormContentPreview,
  imageUploadClientPreview,
} from "../../../../api/services/services";
import backArrow from "../../../../imgs/BackArrow.svg";
import { Grid, Button, Snackbar, Box, Typography } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../../api/config/apiConfig";
import ContactDetailField from "../../../molecules/ContactDetailField";
import TextArea from "../../../atoms/Textarea";
import DynamicCheckbox from "../../../molecules/DynamicCheckbox";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Input from "../../../atoms/Input";
import removeImg from "../../../../imgs/remove.png";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import html2pdf from "html2pdf.js";
import { useParams } from "react-router-dom";
import { ToWords } from "to-words";
import { useLocation } from "react-router-dom";

const InvoiceDownload = ({ formContent, surveyData }) => {
  const [formContentId, setFormContentId] = useState("");

  const [isEdit, setIsEdit] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const urlData = new URLSearchParams(location.search);
  const email = urlData.get("email");
  const surveyId = urlData.get("surveyId");
  const formId = urlData.get("formId");
  const token = urlData.get("token");

  var totalAmount = 0;

  const words = new ToWords();

  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th"; // 11th, 12th, 13th, etc.
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  // Helper function to format the date
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    const ordinalSuffix = getOrdinalSuffix(day);

    return `${day}${ordinalSuffix} ${month}, ${year}`;
  };

  return (
    <>
      <div className="premium-print-container mx-4" style={{ pageBreakInside: 'avoid' }}>
        {/* <MainTemplate> */}
        <div className="section-divider">
          <h1 className="section-title">Invoice</h1>
        </div>

        {/* customer detail*/}
        <Box sx={{ mb: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
                <Box sx={{ display: 'flex', gap: 1, mb: 0.5 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '11px' }}>Invoice No.:</Typography>
                  <Typography variant="body2" sx={{ fontSize: '11px' }}>{formContent?.invoiceNo || "-"}</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1, mb: 0.5 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '11px' }}>Shelozon Vendor #:</Typography>
                  <Typography variant="body2" sx={{ fontSize: '11px' }}>{formContent?.vendorNo || "-"}</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1, mb: 0.5 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '11px' }}>To:</Typography>
                  <Typography variant="body2" sx={{ fontSize: '11px', whiteSpace: 'pre-wrap' }}>{formContent?.to || "-"}</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '11px' }}>For:</Typography>
                  <Typography variant="body2" sx={{ fontSize: '11px', whiteSpace: 'pre-wrap' }}>{formContent?.for || "-"}</Typography>
                </Box>
            </Grid>
            <Grid item xs={4} sx={{ textAlign: 'right' }}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '11px' }}>Date:</Typography>
                  <Typography variant="body2" sx={{ fontSize: '11px' }}>
                    {formContent?.date ? formatDate(formContent?.date) : "-"}
                  </Typography>
                </Box>
            </Grid>
          </Grid>
        </Box>
        {/* /customer detail */}

        <>
          {formContent?.dataRows?.map((row, index) => {
            totalAmount = totalAmount + row?.amount * row?.quantity;
            return <></>;
          })}
        </>

        <div className="table-wrapper mt-1">
          <Table sx={{ borderCollapse: 'collapse', width: '100%' }}>
          {/* Table Header */}
          <thead className="bg-white ">
            <tr>
              <th
                className="border p-1 text-start"
                style={{ width: "10%", fontSize: "10px" }}
              >
                Item No.
              </th>
              <th
                className="border p-1 text-start"
                style={{ width: "30%", fontSize: "10px" }}
              >
                Description
              </th>
              <th
                className="border p-1 text-start"
                style={{ width: "20%", fontSize: "10px" }}
              >
                Quantity
              </th>
              <th
                className="border p-1 text-start"
                style={{ width: "20%", fontSize: "10px" }}
              >
                Amount in PKR/USD/EURO
              </th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {formContent?.dataRows?.length > 0 ? (
              <>
                {formContent?.dataRows.map((row, index) => (
                  <tr key={index}>
                    <td
                      className="border p-1 text-start"
                      style={{ fontSize: "9px" }}
                    >
                      {index + 1}
                    </td>
                    <td
                      className="border p-1 text-start"
                      style={{ fontSize: "9px" }}
                    >
                      {isEdit ? (
                        <Input
                          id="description"
                          label="Description"
                          type="text"
                          style="full-border-field"
                          value={row?.description}
                          inline={{ width: "-webkit-fill-available" }}
                        />
                      ) : row.description ? (
                        row.description
                      ) : (
                        "-"
                      )}
                    </td>
                    <td
                      className="border p-1 text-start"
                      style={{ fontSize: "9px" }}
                    >
                      {isEdit ? (
                        <Input
                          id="amount"
                          label="Qty"
                          type="number"
                          style="full-border-field"
                          value={row?.quantity}
                          inline={{ width: "-webkit-fill-available" }}
                        />
                      ) : row?.quantity ? (
                        row?.quantity
                      ) : (
                        "-"
                      )}
                    </td>

                    <td
                      className="border p-1 text-start"
                      style={{ fontSize: "9px" }}
                    >
                      {isEdit ? (
                        <Input
                          id="amount"
                          label="Price in PKR"
                          type="number"
                          style="full-border-field"
                          value={row?.amount}
                          inline={{ width: "-webkit-fill-available" }}
                        />
                      ) : row?.amount ? (
                        row?.amount
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))}
                <tr>
                  <td
                    className="border p-1 text-start"
                    style={{ fontSize: "11px" }}
                    colSpan={4}
                  >
                    {" "}
                    <b>Grand Total</b>
                  </td>
                </tr>
                <tr>
                  <td
                    className="border p-1 text-start"
                    style={{ fontSize: "9px" }}
                  >
                    <b>-</b>
                  </td>
                  <td
                    className="border p-1 text-start"
                    style={{ fontSize: "9px" }}
                    colSpan={2}
                  >
                    <b>
                      {formContent?.totalAmountinEnglish
                        ? formContent?.totalAmountinEnglish
                        : "-"}{" "}
                    </b>

                    {/* <b> {words?.convert(totalAmount, { currency: true })}
                    </b> */}
                  </td>
                  <td
                    className="border p-1 text-start"
                    style={{ fontSize: "9px" }}
                  >
                    {formContent?.totalAmount ? formContent?.totalAmount : "-"}
                  </td>
                </tr>
              </>
            ) : (
              <tr>
                <td className="text-center" colSpan={9}>
                  {isLoading ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        margin: "10px 0px",
                      }}
                    >
                      <CircularProgress
                        style={{
                          color: "#00aff0",
                          height: "25px",
                          width: "25px",
                        }}
                      />
                    </Box>
                  ) : (
                    <div
                      className="d-flex justify-content-center"
                      style={{ fontSize: "9px" }}
                    >
                      <p className="my-3">No Records to Show</p>
                    </div>
                  )}
                </td>
              </tr>
            )}
          </tbody>
          </Table>
        </div>
        
        {/* Bank Details */}
        <Box sx={{ mt: 2, mb: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '12px', mb: 1 }}>Bank Details:</Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
                <Box sx={{ display: 'flex', gap: 1, mb: 0.5 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '11px' }}>Account Title:</Typography>
                  <Typography variant="body2" sx={{ fontSize: '11px' }}>{formContent?.bankDetails?.title || "-"}</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '11px' }}>IBAN No:</Typography>
                  <Typography variant="body2" sx={{ fontSize: '11px' }}>{formContent?.bankDetails?.iban || "-"}</Typography>
                </Box>
            </Grid>
            <Grid item xs={6}>
                <Box sx={{ display: 'flex', gap: 1, mb: 0.5 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '11px' }}>Swift Code:</Typography>
                  <Typography variant="body2" sx={{ fontSize: '11px' }}>{formContent?.bankDetails?.swiftCode || "-"}</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '11px' }}>Branch Name & Code:</Typography>
                  <Typography variant="body2" sx={{ fontSize: '11px' }}>{formContent?.bankDetails?.branchNameCode || "-"}</Typography>
                </Box>
            </Grid>
          </Grid>
        </Box>
        {/* /Bank Details */}

        {/*  Terms & Conditions:*/}
        {formContent?.termsAndConditions?.trim()?.length > 0 && (
          <Box sx={{ mt: 1 }}>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '11px', whiteSpace: 'nowrap' }}>Terms & Conditions:</Typography>
                <Typography variant="body2" sx={{ fontSize: '11px' }}>{formContent.termsAndConditions}</Typography>
              </Box>
          </Box>
        )}
        {/* / Terms & Conditions */}

        {/*  Validity*/}
        {formContent?.validity?.trim()?.length > 0 && (
          <Box sx={{ mt: 1 }}>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '11px', whiteSpace: 'nowrap' }}>Validity:</Typography>
                <Typography variant="body2" sx={{ fontSize: '11px' }}>{formContent.validity}</Typography>
              </Box>
          </Box>
        )}
        {/* / Validity */}

        <Grid container sx={{ mt: 3 }} justifyContent="flex-end">
          <Grid item xs={6} sx={{ textAlign: 'center' }}>
            <div style={{ height: "80px", display: 'flex', justifyContent: 'center', alignItems: 'flex-end', borderBottom: '1px solid #000', marginBottom: '8px', width: '200px', margin: '0 auto' }}>
              {formContent?.adminSign?.trim()?.length > 0 && (
                <img src={`${Bucket}${formContent.adminSign}`} height={70} style={{ objectFit: 'contain' }} />
              )}
            </div>
            <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '11px' }}>
              Shelozon Movers Packers & Logistics Pvt Ltd
            </Typography>
          </Grid>
        </Grid>

        {/* </MainTemplate> */}
      </div>
    </>
  );
};

export default InvoiceDownload;
